













































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CardTitle from '@/components/common/CardTitle.vue';
import ChoiceSubmitter from '@/views/ChoiceSubmitter/ChoiceSubmitter.vue';
import Decisions from '@/store/modules/Decisions';
import { getModule } from 'vuex-module-decorators';
import Choices, { Choice } from '@/store/modules/Choices';
import { watch } from 'fs';

const choicesModule = getModule(Choices);
const decisionsModule = getModule(Decisions);

@Component({
    components: { CardTitle, ChoiceSubmitter: () => import('@/views/ChoiceSubmitter/ChoiceSubmitter.vue')},
})
export default class ChoiceInputDialog extends Vue {

    private show: boolean = false;
    @Prop({ default: '', type: String })
    cardTitle!: string;

    @Prop({ default: '800px', type: String })
    width!: string;
    @Prop({ default: '640px', type: String })
    height!: string;
    @Prop({ default: '100%', type: String })
    maxWidth!: string;
    @Prop({ default: '100%', type: String })
    maxHeight!: string;

    @Prop({ default: false, type: Boolean })
    isEdit!: boolean;

    @Prop({ default: false, type: Boolean })
    fullscreen!: boolean;

    @Prop({ default: '', type: String })
    choiceName!: string;

    @Prop({default: false, type: Boolean})
    icon!: boolean

    @Prop({default: true, type: Boolean})
    addToList!: boolean

    @Prop({ default: '', type: String })
    choiceId!: string;
    
    @Prop({ default: false, type: Boolean})
    dialogOpen!: boolean

    @Prop({ default: true, type: Boolean})
    showComments!: boolean

    private isClear = false;

    private dialogSave = false;

    private isNewChoiceNameDialog = false;

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    @Watch('dialogOpen')
    onChangeDialogOpen(){
        if (this.dialogOpen) {
            this.show = true;
            if (!this.isEdit) {
                this.isNewChoiceNameDialog = true;
            }else{
                this.isNewChoiceNameDialog = false;
            }
        }
    }

    @Watch('show')
    onChangeShow(){
        if (!this.show) {
            this.$emit('dialogClosed');
            this.isNewChoiceNameDialog = false;
        } else {
            if (!this.isEdit) {
                this.isNewChoiceNameDialog = true;
            }else{
                this.isNewChoiceNameDialog = false;
            }
        }
    }

    private save() {
        this.dialogSave = true;
    }

    private async selectChoice() {
        await choicesModule.selectChoice(this.choiceId)
    }

    saveChoice() {
        // console.log('saved');
        this.dialogSave = false;
        this.show = false;
        this.isNewChoiceNameDialog = false;
        this.$emit('savechoice');
    }
    private failSave(){
        this.dialogSave = false;
    }
    private clearVars() {
        this.isClear = true;
    }
    private cancel(){
        this.dialogSave = false;
        this.show = false;
    }
}
